import { useEffect, useSyncExternalStore } from "react";
import { toast } from "sonner";

const KEY = "porosity_designer";
const EVENT = "porosity-designer-change";

function read() {
  try {
    return localStorage.getItem(KEY) === "1";
  } catch {
    return false;
  }
}

export function setDesignerMode(on) {
  if (on === read()) return;
  try {
    if (on) localStorage.setItem(KEY, "1");
    else localStorage.removeItem(KEY);
  } catch {
    /* ignore */
  }
  window.dispatchEvent(new Event(EVENT));
  toast(on ? "Designer mode on" : "Designer mode off");
}

export const toggleDesignerMode = () => setDesignerMode(!read());

function subscribe(cb) {
  const onStorage = (e) => e.key === KEY && cb();
  window.addEventListener(EVENT, cb);
  window.addEventListener("storage", onStorage);
  return () => {
    window.removeEventListener(EVENT, cb);
    window.removeEventListener("storage", onStorage);
  };
}

export default function useDesignerMode() {
  return useSyncExternalStore(subscribe, read, () => false);
}

// Mounted once in App: ?designer=1/0 link and the Ctrl+Alt+D shortcut.
export function useDesignerTriggers(search) {
  useEffect(() => {
    const params = new URLSearchParams(search);
    const v = params.get("designer");
    if (v === null) return;
    if (v === "1") setDesignerMode(true);
    else if (v === "0") setDesignerMode(false);
    params.delete("designer");
    const q = params.toString();
    const url = window.location.pathname + (q ? `?${q}` : "") + window.location.hash;
    window.history.replaceState(window.history.state, "", url);
  }, [search]);

  useEffect(() => {
    const onKey = (e) => {
      if (!(e.ctrlKey && e.altKey && !e.shiftKey && !e.metaKey && e.code === "KeyD")) return;
      const t = e.target;
      if (t && (t.tagName === "INPUT" || t.tagName === "TEXTAREA" || t.tagName === "SELECT" || t.isContentEditable)) return;
      e.preventDefault();
      toggleDesignerMode();
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, []);
}
